import { render, staticRenderFns } from "./territoryManagement.vue?vue&type=template&id=8657d682&scoped=true&"
import script from "./territoryManagement.vue?vue&type=script&lang=js&"
export * from "./territoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./territoryManagement.vue?vue&type=style&index=0&id=8657d682&scoped=true&lang=css&"
import style1 from "./territoryManagement.vue?vue&type=style&index=1&id=8657d682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8657d682",
  null
  
)

export default component.exports